import { render } from "./GroupCardCarousel.vue?vue&type=template&id=628529a0&scoped=true"
import script from "./GroupCardCarousel.vue?vue&type=script&lang=js"
export * from "./GroupCardCarousel.vue?vue&type=script&lang=js"

import "./GroupCardCarousel.vue?vue&type=style&index=0&id=628529a0&scoped=true&lang=css"

import exportComponent from "D:\\a\\1\\a\\WebApp\\FAOU.App\\clientapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-628529a0"]])

export default __exports__